import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import makeStyles from '@mui/styles/makeStyles';

import { Loader, PanelTitle } from 'ui';
import { EmptyDataLabel } from 'ui/Labels';

import { types, TypesEnum } from '../constants/types';
import { fetchNotificationsWidget } from '../services/notificationsService';

const useValueStyles = makeStyles({
  primary: {
    textAlign: 'right',
  },
});

interface NotificationsResponse {
  [TypesEnum.ACCOUNT_NOTIFICATIONS]: any;
  [TypesEnum.SYSTEM_UPDATE]: any;
  [TypesEnum.RESPONSE]: any;
  [TypesEnum.WHATS_NEW]: any;
  [TypesEnum.DOWNLOADS]: any;
  [TypesEnum.UPLOADS]: any;
}

/**
 * @deprecated
 */
const NotificationsWidget = () => {
  const { t } = useTranslation();
  const valueClasses = useValueStyles();
  const [isPending, setIsPending] = useState(true);
  const [data, setData] = useState<NotificationsResponse>();

  useEffect(() => {
    let isMounted = true;
    fetchNotificationsWidget()
      .then((response: any) => {
        if (!isMounted) {
          return;
        }

        setData(response);
        setIsPending(false);
      })
      .catch(() => {
        if (!isMounted) {
          return;
        }

        setIsPending(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  const keys = data ? Object.keys(data as NotificationsResponse) : [];

  return (
    <>
      <PanelTitle>{t('NOTIFICATIONS_CENTRE.WIDGET.TITLE')}</PanelTitle>
      <Paper>
        {isPending ? (
          <Box py={1}>
            <Loader center />
          </Box>
        ) : (
          <List>
            {(keys as Array<TypesEnum>).map((key, index) => {
              const { label } = types[key];

              return (
                <ListItem key={key} divider={keys.length !== index + 1}>
                  <ListItemText>{t(label)}</ListItemText>
                  <ListItemText classes={valueClasses}>{data ? data[key] : ''}</ListItemText>
                </ListItem>
              );
            })}
            {!isPending && !keys.length && (
              <EmptyDataLabel label={t('NOTIFICATIONS_CENTRE.WIDGET.EMPTY')} />
            )}
          </List>
        )}
      </Paper>
    </>
  );
};

export { NotificationsWidget };
